import React from 'react'
import MaintenancePage from '../../Pages/maintainnance/MaintenancePage'

const Upes = () => {
  return (
    <>
    <MaintenancePage />
    </>
  )
}

export default Upes